var _ASSET_PERSONALIZATIO, _ASSET_PERSONALIZATIO2;
import { gate } from 'hub-http/gates';
import { ASSET_TYPES } from 'personalization-lib/constants/assetTypes';
export const READ_SCOPES = {
  [ASSET_TYPES.LANDING_PAGE]: 'landingpages-access',
  [ASSET_TYPES.WEB_INTERACTIVE]: 'calls-to-action-read',
  [ASSET_TYPES.WEBSITE_PAGE]: 'sitepages-access'
};
export const ASSET_PERSONALIZATION_SCOPES = {
  [ASSET_TYPES.LANDING_PAGE]: ['landing-pages-personalization-access'],
  [ASSET_TYPES.WEBSITE_PAGE]: ['site-pages-personalization-access']
};
export const WRITE_SCOPES = {
  [ASSET_TYPES.LANDING_PAGE]: ['landingpages-write', ...((_ASSET_PERSONALIZATIO = ASSET_PERSONALIZATION_SCOPES[ASSET_TYPES.LANDING_PAGE]) !== null && _ASSET_PERSONALIZATIO !== void 0 ? _ASSET_PERSONALIZATIO : [])],
  [ASSET_TYPES.WEB_INTERACTIVE]: ['calls-to-action-edit'],
  [ASSET_TYPES.WEBSITE_PAGE]: ['pages-write', ...((_ASSET_PERSONALIZATIO2 = ASSET_PERSONALIZATION_SCOPES[ASSET_TYPES.WEBSITE_PAGE]) !== null && _ASSET_PERSONALIZATIO2 !== void 0 ? _ASSET_PERSONALIZATIO2 : [])]
};
export const FEATURE_GATES = {
  webVisitors: gate('CRM:Segments:WebVisitors'),
  websitePages: gate('Personalize:WebsitePages'),
  createVariantInEditor: gate('Personalize:CreateVariantInEditor'),
  ctaV2Editor: gate('WebInteractives:ScalableEditor'),
  agentSunset: gate('Personalize:AgentSunset'),
  variantsPreview: gate('Personalize:VariantsPreview')
};